import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)
const lang = localStorage.i18nextLng
export const successAlert = () => {
  return MySwal.fire({
    title: lang === 'en' ? 'Good job!' : 'عمل جيد!',
    text: lang === 'en' ? 'Your work has been completed!' : 'لقد تم انجاز العمل بنجاح!',
    icon: 'success',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false
  })
}

export const warningAlert = message => {
  return MySwal.fire({
    title: lang === 'en' ? 'Warning!' : 'تحذير!',
    text: message || ' You clicked the button!',
    icon: 'warning',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false
  })
}

export const errorAlert = message => {
  return MySwal.fire({
    title: lang === 'en' ? 'Oops...' : 'خطأ...',
    text: message ? message : lang === 'en' ? 'Somthing went Wrong!' : 'حدث خطأ ما!',
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false
  })
}

export const confirmAlert = (id, Action) => {
  return MySwal.fire({
    title: lang === 'en' ? 'Are you sure?' : 'هل انت متاكد من ذلك',
    text: lang === 'en' ? "You won't be able to revert this!" : 'لن تستطيع التراجع!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: lang === 'en' ? 'Yes!' : 'موافق!',
    cancelButtonText: lang === 'en' ? 'No' : 'كلا',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-danger ms-1'
    },
    buttonsStyling: false
  }).then(function (result) {
    if (result.value) {
      Action(id)
    }
  })
}
